import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiRecipientEmailInputComponent } from './multi-recipient-email-input.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';



@NgModule({
  declarations: [MultiRecipientEmailInputComponent],
  exports: [
    MultiRecipientEmailInputComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule,
    MatOptionModule
  ]
})
export class MultiRecipientEmailInputModule { }
